import {ReactComponent as NoTransactionIcon} from './noTransaction.svg'

function NoTransaction() {
  return <NoTransactionIcon />
}

export default NoTransaction
